import { call, put, all, takeEvery, takeLatest, race, take } from 'redux-saga/effects'

import {
  getCombinedCampaignsService,
  getCombinedLineItemsService,
  getCombinedGraphsService,
  getCombinedSegmentedDataService,
  getCombinedAdsService,
  exportCombinedCampaignsDataAsCsvService
} from '../services/combinedData'
import {
  GET_COMBINED_CAMPAIGNS,
  getCombinedCampaignsSuccess,
  getCombinedCampaignsFailure,
  CLEAR_COMBINED_CAMPAIGNS,
  GET_COMBINED_LINE_ITEMS,
  getCombinedLineItemsSuccess,
  getCombinedLineItemsFailure,
  GET_COMBINED_GRAPHS,
  getCombinedGraphsSuccess,
  getCombinedGraphsFailure,
  GET_COMBINED_SEGMENTED_DATA,
  getCombinedSegmentedDataSuccess,
  getCombinedSegmentedDataFailure,
  GET_COMBINED_ADS,
  getCombinedAdsSuccess,
  getCombinedAdsFailure,
  EXPORT_COMBINED_CAMPAIGNS_DATA_AS_CSV,
  exportCombinedCampaignsDataAsCsvSuccess,
  exportCombinedCampaignsDataAsCsvFailure
} from '../actions/combinedData'

import { DATE_STATIC_PRESET } from '../../constants/selectLists/listItemFiltersList'

function* combinedDataWatcher() {
  yield all([
    // PLOP_APPEND_PATTERN_ANCHOR_WATCHER
    takeLatest(GET_COMBINED_CAMPAIGNS, getCombinedCampaignsWorker),
    takeEvery(GET_COMBINED_LINE_ITEMS, getCombinedLineItemsWorker),
    takeEvery(GET_COMBINED_GRAPHS, getCombinedGraphsWorker),
    takeEvery(GET_COMBINED_SEGMENTED_DATA, getCombinedSegmentedDataWorker),
    takeEvery(GET_COMBINED_ADS, getCombinedAdsWorker),
    takeEvery(EXPORT_COMBINED_CAMPAIGNS_DATA_AS_CSV, exportCombinedCampaignsDataAsCsvWorker)
  ])
}

// PLOP_APPEND_PATTERN_ANCHOR_WORKER

function* getCombinedCampaignsWorker({ data }) {
  const datePreset = data?.[DATE_STATIC_PRESET]

  try {
    const { response } = yield race({
      response: call(getCombinedCampaignsService, data),
      // need to cancel previous task, if user change the page, but task still in progress
      cancel: take(CLEAR_COMBINED_CAMPAIGNS)
    })

    if (response) {
      // We pass datePreset to success action to store lifetime combinedCampaigns data separately,
      // and not overwrite it with other date presets
      yield put(getCombinedCampaignsSuccess(response, datePreset))
    }
  } catch (e) {
    yield put(getCombinedCampaignsFailure(e))
  }
}

function* getCombinedLineItemsWorker({ data }) {
  const { date_from, date_to } = data
  const dateRange = { date_from, date_to }

  try {
    const response = yield call(getCombinedLineItemsService, data)
    // We pass dateRange to success action to store lifetime lineItems data separately,
    // and not overwrite it with other date ranges
    yield put(getCombinedLineItemsSuccess(response, dateRange))
  } catch (e) {
    yield put(getCombinedLineItemsFailure(e))
  }
}

function* getCombinedGraphsWorker({ data }) {
  try {
    const response = yield call(getCombinedGraphsService, data)
    yield put(getCombinedGraphsSuccess(response))
  } catch (e) {
    yield put(getCombinedGraphsFailure(e))
  }
}

function* getCombinedSegmentedDataWorker({ data }) {
  try {
    const response = yield call(getCombinedSegmentedDataService, data)
    yield put(getCombinedSegmentedDataSuccess(response))
  } catch (e) {
    yield put(getCombinedSegmentedDataFailure(e))
  }
}

function* getCombinedAdsWorker({ data }) {
  try {
    const response = yield call(getCombinedAdsService, data)
    yield put(getCombinedAdsSuccess(response))
  } catch (e) {
    yield put(getCombinedAdsFailure(e))
  }
}

function* exportCombinedCampaignsDataAsCsvWorker({ data }) {
  try {
    const response = yield call(exportCombinedCampaignsDataAsCsvService, data)
    yield put(exportCombinedCampaignsDataAsCsvSuccess(response))
  } catch (error) {
    yield put(exportCombinedCampaignsDataAsCsvFailure(error))
  }
}

export default combinedDataWatcher
